/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useDownloadNodeLogsFormStyles = makeStyles((theme: Theme) => ({
  popoverButons: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    justifyContent: 'space-between',
  },
  form: {
    width: '350px',
    maxWidth: '350px',
  },
  heading: {
    color: theme.palette.primary.main,
    marginBottom: '15px',
  },
  pl10: {
    paddingLeft: '10px',
  },
}));

export { useDownloadNodeLogsFormStyles };
